<template>
    <div class="w-100">
        <b-form-tags
            class="select-cover"
            v-model="selectedItem"
            add-on-change
            no-outer-focus
            @input="whenChange">
            <template v-slot="{tags, inputAttrs, inputHandlers, disabled, removeTag}">
                <div class="position-relative">
                    <ul v-if="tags.length > 0" class="list-inline d-inline-block position-absolute tag-cover">
                        <li v-for="tag in tags" :key="tag" class="list-inline-item">
                            <b-form-tag
                                class="tag-item"
                                @remove="removeTag(tag)"
                                :title="tag"
                                :disabled="disabled"
                                variant="light">
                                {{ tag }}
                            </b-form-tag>
                        </li>
                    </ul>
                    <b-form-select
                        :state="state"
                        v-bind="inputAttrs"
                        v-on="inputHandlers"
                        :disabled="disabled || availableOptions.length === 0"
                        :options="availableOptions"
                        @input="$emit('blur')">
                    </b-form-select>
                </div>
            </template>
        </b-form-tags>
    </div>
</template>

<script>

export default {
    name: "MiniMultiSelect",
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        state: Boolean
    },
    computed: {
        availableOptions() {
            return this.options.filter(opt => this.selectedItem.indexOf(opt) === -1)
        }
    },
    data() {
        return {
            selectedItem: []
        }
    },
    watch: {
        value: {
            handler() {
                if (this.value !== undefined && this.value != null) {
                    this.selectedItem = this.value.split(",");
                }
            },
        }
    },
    methods: {
        whenChange(value) {
            console.log('-----change')
            this.$emit('update:value', value.join(","));
        },
    }
}
</script>

<style scoped>
.tag-cover {
    top: 5px;
    left: 5px;
    z-index: 999;
}

.tag-item {
    cursor: pointer;
}

.select-cover {
    padding: 0 !important;
    border: 0 !important;
}
</style>